import {AxiosCall} from '../axios';
import {environment} from '../environment/environment';
import {ServiceSuccessResponseType} from './service-mappers/BaseMapper';

const messageBase = environment.apiEndPoints.messages.base;
const endPoints = environment.apiEndPoints.messages.endPoints;

export const getMessageConversation = async (
  clinicGroupId: number,
  clinicId: number,
  messageId: number
): Promise<ServiceSuccessResponseType<any>> => {
  const url = `/clinic-group/${clinicGroupId}/clinic/${clinicId}${messageBase}/${messageId}${endPoints.conversation}`;
  return AxiosCall.get(url);
};

export const getAMessage = async (
  clinicGroupId: number,
  clinicId: number,
  messageId: number
): Promise<ServiceSuccessResponseType<any>> => {
  const url = `/clinic-group/${clinicGroupId}/clinic/${clinicId}${messageBase}/${messageId}`;
  return AxiosCall.get(url);
};

export const respondToMessage = async (
  clinicGroupId: number,
  clinicId: number,
  messageId: number,
  text: string,
  templateNameId: string,
  defaultEventType?: string | null
): Promise<ServiceSuccessResponseType<any>> => {
  const url = `/clinic-group/${clinicGroupId}/clinic/${clinicId}${messageBase}/${messageId}${endPoints.respond}`;
  return AxiosCall.post(url, {
    text,
    template_name_id: templateNameId,
    default_event_type: defaultEventType
  });
};

export const archiveAMessage = async (
  clinicGroupId: number,
  clinicId: number,
  messageId: number,
  shouldArchive: boolean
): Promise<ServiceSuccessResponseType<any>> => {
  const url = `/clinic-group/${clinicGroupId}/clinic/${clinicId}${messageBase}/${messageId}${endPoints.archive}`;
  return AxiosCall.post(url, {should_archive: shouldArchive});
};

export const updateMessageEventTypeStatus = async (
  clinicGroupId: number,
  clinicId: number,
  messageId: number,
  status: string | null,
  notes?: string
): Promise<ServiceSuccessResponseType<any>> => {
  const url = `/clinic-group/${clinicGroupId}/clinic/${clinicId}${messageBase}/${messageId}${endPoints.eventTypeStatus}`;
  return AxiosCall.post(url, {status, notes});
};

export const markAMessageAsRead = async (
  clinicGroupId: number,
  clinicId: number,
  messageId: number,
  isRead: boolean
): Promise<ServiceSuccessResponseType<any>> => {
  const url = `/clinic-group/${clinicGroupId}/clinic/${clinicId}${messageBase}/${messageId}${endPoints.markRead}`;
  return AxiosCall.post(url, {is_read: isRead});
};

export const getMatchedGuarantors = async (
  clinicGroupId: number,
  clinicId: number,
  messageId: number
): Promise<ServiceSuccessResponseType<any>> => {
  const url = `/clinic-group/${clinicGroupId}/clinic/${clinicId}${messageBase}/${messageId}${endPoints.matchedGuarantors}`;
  return AxiosCall.get(url);
};

export const changeGuarantor = async (
  clinicGroupId: number,
  clinicId: number,
  messageId: number,
  guarantorId: number
): Promise<ServiceSuccessResponseType<any>> => {
  const url = `/clinic-group/${clinicGroupId}/clinic/${clinicId}${messageBase}/${messageId}${endPoints.changeGuarantor}`;
  return AxiosCall.post(url, {guarantor_id: guarantorId});
};

export const getLastMessage = async (
  clinicGroupId: number,
  clinicId: number,
  guarantorId: number
): Promise<ServiceSuccessResponseType<any>> => {
  const url = `/clinic-group/${clinicGroupId}/clinic/${clinicId}${messageBase}/last_message?clinic_id=${clinicId}&guarantor_id=${guarantorId}`;
  return AxiosCall.get(url);
};

export const startANewMessage = async (
  clinicGroupId: number,
  clinic_id: number,
  guarantor_id: number,
  text: string,
  template_name_id: string,
  defaultEventType?: string | null
): Promise<ServiceSuccessResponseType<any>> => {
  const url = `/clinic-group/${clinicGroupId}/clinic/${clinic_id}${messageBase}/new-message`;
  return AxiosCall.post(url, {
    guarantor_id,
    text,
    template_name_id,
    default_event_type: defaultEventType
  });
};

export const addMessageToUser = async (
  clinicGroupId: number,
  clinicId: number,
  userId: number,
  messageId: number
): Promise<any> => {
  const url = `/clinic-group/${clinicGroupId}/clinic/${clinicId}/messages/${messageId}/assign-user`;

  const payload = {
    user_id: userId
  };
  return AxiosCall.post(url, payload);
};

export const getUserMessageInboxes = async (
  reference_key: string
): Promise<any> => {
  const url = `/reference-data/${reference_key}`;

  return AxiosCall.get(url);
};

export const getUserCustomMessageInboxes = async (
  clinicGroupId: number
): Promise<any> => {
  const url = `/clinic-group/${clinicGroupId}/all-custom-message-inboxes`;
  return AxiosCall.get(url);
};

export const createUserCustomInbox = async (
  clinicGroupId: number,
  payload: any
): Promise<any> => {
  const url = `/clinic-group/${clinicGroupId}/create-custom-message-inbox`;

  return AxiosCall.post(url, payload);
};

export const moveMessageToInbox = async (
  clinicGroupId: number,
  clinicId: number,
  messageId: any,
  payload: any
): Promise<any> => {
  const url = `/clinic-group/${clinicGroupId}/clinic/${clinicId}/messages/${messageId}/add-message-to-custom-inbox`;

  return AxiosCall.post(url, payload);
};

export const updateMessageCategoryType = async (
  clinicGroupId: number,
  clinicId: number,
  messageId: number,
  message_category: string | null
): Promise<ServiceSuccessResponseType<any>> => {
  const url = `/clinic-group/${clinicGroupId}/clinic/${clinicId}/messages/${messageId}/message-category`;
  return AxiosCall.post(url, {message_category});
};

export const deleteCustomInbox = async (
  clinic_group_id: number | string,
  inbox_id: number | string
): Promise<any> => {
  return AxiosCall.delete(
    `/clinic-group/${clinic_group_id}/message-inbox/${inbox_id}`
  );
};

export const updateCustomInbox = async (
  clinicGroupId: number | string,
  inboxId: number | string,
  payload: { label: string }
): Promise<any> => {
  return AxiosCall.put(
    `/clinic-group/${clinicGroupId}/message-inbox/${inboxId}`,
    payload
  );
};
